module.exports = "/images/PeopleNegotiating.png?bc26ecb6443a64b4fc897c44d5a0da36";